import React from 'react';
import { CalendarEvent } from '../../types/calendar';
import { Clock, CalendarDays } from 'lucide-react';
interface UpcomingEventsListProps {
  events: CalendarEvent[];
}
export function UpcomingEventsList({
  events
}: UpcomingEventsListProps) {
  const now = new Date();
  const sortedEvents = [...events].filter(e => new Date(e.start) >= now).sort((a, b) => new Date(a.start).getTime() - new Date(b.start).getTime());
  const upcoming = sortedEvents.slice(0, 6);
  const formatDate = (isoString: string) => {
    const date = new Date(isoString);
    const today = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);
    if (date.toDateString() === today.toDateString()) return 'Hoy';
    if (date.toDateString() === tomorrow.toDateString()) return 'Mañana';
    return date.toLocaleDateString('es-ES', {
      weekday: 'short',
      day: 'numeric',
      month: 'short'
    });
  };
  const formatTime = (isoString: string) => new Date(isoString).toLocaleTimeString('es-ES', {
    hour: '2-digit',
    minute: '2-digit'
  });
  const accentForType = (type: string) => {
    switch (type) {
      case 'Demo':
        return 'bg-growthly-green';
      case 'Propuesta':
        return 'bg-growthly-amber';
      case 'Cancelado':
        return 'bg-growthly-red';
      default:
        return 'bg-white/60';
    }
  };
  return <div className="card p-5 h-full overflow-y-auto" data-id="element-148">
      <div className="flex items-center gap-2 mb-5" data-id="element-149">
        <div className="w-8 h-8 rounded-lg bg-white/[0.04] border border-white/[0.06] flex items-center justify-center" data-id="element-150">
          <CalendarDays className="w-4 h-4 text-growthly-text" data-id="element-151" />
        </div>
        <h3 className="text-[15px] font-semibold text-white" data-id="element-152">
          Próximos eventos
        </h3>
      </div>

      {upcoming.length === 0 ? <div className="py-10 text-center" data-id="element-153">
          <div className="w-12 h-12 rounded-full bg-white/[0.03] border border-white/[0.06] flex items-center justify-center mx-auto mb-3" data-id="element-154">
            <Clock className="w-5 h-5 text-growthly-muted" data-id="element-155" />
          </div>
          <p className="text-[13px] text-growthly-muted" data-id="element-156">
            No hay eventos próximos.
          </p>
          <p className="text-[12px] text-growthly-muted/70 mt-1" data-id="element-157">
            Agenda uno desde el calendario.
          </p>
        </div> : <div className="space-y-2.5" data-id="element-158">
          {upcoming.map(event => <div key={event.id} className="group flex items-stretch gap-3 p-3 rounded-lg bg-white/[0.02] border border-white/[0.04] hover:bg-white/[0.05] hover:border-white/[0.08] transition-all cursor-pointer" data-id="element-159">
              <div className={`w-1 rounded-full ${accentForType(event.type)} flex-shrink-0`} data-id="element-160" />
              <div className="flex-1 min-w-0" data-id="element-161">
                <div className="flex items-center justify-between gap-2 mb-1" data-id="element-162">
                  <span className="text-[11px] font-semibold text-growthly-muted uppercase tracking-wider" data-id="element-163">
                    {formatDate(event.start)}
                  </span>
                  <span className="text-[11px] text-growthly-muted font-medium" data-id="element-164">
                    {formatTime(event.start)}
                  </span>
                </div>
                <p className="text-[13px] font-medium text-white truncate leading-tight" data-id="element-165">
                  {event.leadName}
                </p>
                <p className="text-[11px] text-growthly-muted truncate mt-0.5" data-id="element-166">
                  {event.type} · {event.title}
                </p>
              </div>
            </div>)}
        </div>}
    </div>;
}